var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.887695,
    width: 24.3952,
    height: 24.3952,
    rx: 2.90419,
    fill: "#D9EBC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_5197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1171 13.744V18.8728H11.249V13.744V13.4536H10.9586H9.25917V11.7927H10.9586H11.249V11.5023V9.79373C11.249 8.88072 11.5225 8.20747 11.9717 7.7625C12.4216 7.31687 13.0815 7.06679 13.9187 7.06679C14.3321 7.06679 14.7586 7.10342 15.0843 7.14063C15.1984 7.15367 15.2994 7.1667 15.3824 7.1781V8.54599H14.6846C14.1358 8.54599 13.7279 8.71696 13.4623 9.02087C13.2032 9.31743 13.1171 9.69798 13.1171 10.0475V11.5023V11.7927H13.4075H15.2422L14.9846 13.4536H13.4075H13.1171V13.744Z",
    fill: "#69A42E",
    stroke: "#69A42E",
    strokeWidth: 0.580838
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_5197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.82329,
    height: 12.3869,
    fill: "white",
    transform: "translate(8.41016 6.77637)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGreen);
export default __webpack_public_path__ + "static/media/facebook_green.41cabde4e0c3873d5bd8a718ca50384f.svg";
export { ForwardRef as ReactComponent };